/**
 * Created by renlaydel on 13/12/2017.
 */
import * as apiCommon from '../../apiCommon';
import { ITEM_LOCATION } from '../../../constants/constant_doc_types';

export const getItemLocation = async (app, params) => {
  const { itemId, locationId } = params;
  const result = await apiCommon.queryDocs(
    app,
    ITEM_LOCATION + `/${itemId}:${locationId}`,
  );
  return result || null;
};

export const getItemLocationsByIds = async (app, ids) => {
  const filters = {
    _id: [...ids],
  };
  const result = await apiCommon.getListData(app, {
    filters,
    list_type: 'item_location',
  });
  return result.docs;
};

export const getItemLocations = async (app, whereIn) => {
  const itemIds = [];
  const locationIds = [];
  whereIn.forEach(({ item_id, location_id }) => {
    if (item_id) {
      itemIds.push(item_id);
    }

    if (location_id) {
      locationIds.push(location_id);
    }
  });
  const result = await apiCommon.queryDocs(
    app,
    ITEM_LOCATION,
    {
      where: {
        item_id: {
          $in: itemIds,
        },
        location_id: {
          $in: locationIds,
        },
      },
      limit: itemIds.length,
      fields: ['supplier']
    },
    'post',
  );
  return result.data;
};
